import styled from 'styled-components';
import { Card } from '../../atoms/Card';
import { tvar } from '@versita/frontend/design-tokens';

export const StyledStats = styled.div`
  display: flex;

  &:not(:last-child) {
    margin-bottom: ${tvar('space.x3')};
  }
`;

export const StyledStat = styled(Card)`
  width: max-content;
  max-width: 100%;
  margin-bottom: ${tvar('space.x2')} !important;

  h4 {
    font-size: ${tvar('typographies.small.fontSize')};
  }

  p {
    font-weight: 500;
    margin-bottom: 0;
    font-size: ${tvar('typographies.h1.fontSize')};
    line-height: ${tvar('typographies.h1.lineHeight')};
  }

  &:not(:last-child) {
    margin-right: ${tvar('space.x4')};
  }
`;
